import { render, staticRenderFns } from "./SithMesPrdManBorrowProcessList.vue?vue&type=template&id=0d487202&"
import script from "./SithMesPrdManBorrowProcessList.vue?vue&type=script&lang=js&"
export * from "./SithMesPrdManBorrowProcessList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports